import React, { useRef, useState } from "react";
import Tooltip from '@mui/material/Tooltip';

//Importar íconos y dependencias de switch de Material UI.
import { AccountCircle } from '@mui/icons-material/';
import MenuUserProfile from "./MenuUserProfile";
import ModalCreateNewPassword from "../common/Modal/ModalCreateNewPassword";
import ModalMessageAlert from "./Modal/ModalMessageAlert";
import useClickOutside from "../../hooks/useClickOutside";


// UserProfileWithRol: Componente que renderiza los datos del perfil del usuario con el menú para autoasignación.

const UserProfileWithRol = () => {

    const userData = JSON.parse(localStorage.getItem("userData")); //Extraer del localStorage los datos del usuasrio logeado.
    const [openMenuUserProfile, setOpenMenuUserProfile] = useState(false); //Estado para abrir y cerrar el modal del perfil del perfil del usuario
    const [openCreateNewPassword, setOpenCreateNewPassword] = useState(false); //Estado para abrir el menú para restablecer la contraseña del usuario.
    const [passwordEditedSuccess, setPasswordEditedSuccess] = useState(false); //Estado para mostrar que la contraseña se editó correctamente.
    const menuRef = useRef(null); // Referencia al contenedor del menú

    const handleCloseMessageAlert = () => setPasswordEditedSuccess(false);
    
    const containerStyle = {
        border: openMenuUserProfile ? '2px solid white' : '2px solid transparent',
        transition: 'border-color 0.15s cubic-bezier(0.4, 0, 0.2, 1)',
    };

    useClickOutside(menuRef, () => setOpenMenuUserProfile(false));

    return (
        <>
            <div className="content-navigation__user">
                <Tooltip title="Perfil del usuario" >
                    <div className="content-navigation__user--with-padding border-animation" ref={menuRef} 
                    style={ containerStyle } 
                    onClick={() => setOpenMenuUserProfile(!openMenuUserProfile)}>
                        <div className="content-navigation__user-texts">
                            <div className="navigation-texts">
                                <label className="navigation__welcome">Bienvenido, </label>
                                <label className="navigation__user-name">{userData.Nombre}</label>
                            </div>
                        </div>
                        <AccountCircle  sx={{ color: 'var(--ligth-color)', fontSize: '30px', marginLeft: '10px' }} />
                    </div>
                </Tooltip>
            </div>
            
            {/*------Menú con las acciones para autoasignación y restablecer la contraseña--- */}
            {openMenuUserProfile && <MenuUserProfile setOpenCreateNewPassword={setOpenCreateNewPassword} /> }

            {/*------Menú para restablecer la contraseña del usuario--- */}
            <ModalCreateNewPassword openCreateNewPassword={openCreateNewPassword} setOpenCreateNewPassword={setOpenCreateNewPassword}
            setPasswordEditedSuccess={setPasswordEditedSuccess} />
            
            {/*------Alerta de que se editó correctamente la contraseña--- */}
            {passwordEditedSuccess && <ModalMessageAlert open={passwordEditedSuccess}  message="Contraseña editada correctamente" 
            onClose={handleCloseMessageAlert} />}
        </>
    )
};

export default UserProfileWithRol;
